/* eslint-disable no-unused-vars */
import { ModalBase, ModalHeader, ChooseBase, ModalFooter } from 'components';
import * as S from './ChooseLanguage.styled';
import { useFacade } from './useFacade';

import { Content } from './Content';

const ChooseLanguage = ({ close, title }) => {
  const {
    search,
    handleSearchOnChange,
    handleClearSearchValue,
    sortedLangs,
    isActive,
    toggle,
    state: selectedVersions,
    toggleAllOff,
    saveButtonClick,
    saveBtnFlag,
  } = useFacade();

  return (
    <ModalBase>
      <S.Box>
        <ModalHeader title={title} close={close} />
        <S.Content>
          <ChooseBase.OneSection
            showBtnDeselectAll={selectedVersions.length}
            handleDeselectAll={toggleAllOff}
            title='Search Language'
            searchValue={search}
            searchOnChange={handleSearchOnChange}
            handleClearSearchValue={handleClearSearchValue}
          >
            <Content
              toggle={toggle}
              faundedLangs={sortedLangs}
              search={search}
              isActive={isActive}
            />
          </ChooseBase.OneSection>
        </S.Content>
        <ModalFooter
          saveButtonText='Apply'
          saveButtonOnClick={() => {
            saveButtonClick();
            close();
          }}
          close={close}
          saveButtonDisabled={saveBtnFlag.current}
        />
      </S.Box>
    </ModalBase>
  );
};

export default ChooseLanguage;
